export const SUPPORTED_MAP_AREAS = ['a_NAM', 'a_EUROPE', 'a_AMWA', 'a_APAC']
